import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SourceContext, ConfigData } from '../../../models/source-panel.models';
import { SOURCE_PANEL_API } from '../../../services/source-panel-api/source-panel-api.interface';
import { RegulationAgentSourceApiService } from '../../services/regulation-agent-source-api/regulation-agent-source-api.service';

/**
 * Wrapper that provides RegulationAgentSourceApiService for the source panel
 * when used in the regulation agent. Use only when agentId === 'regulations_agent'.
 */
@Component({
  selector: 'app-agent-source-panel-wrapper',
  templateUrl: './agent-source-panel-wrapper.component.html',
  styleUrls: ['./agent-source-panel-wrapper.component.scss'],
  providers: [
    { provide: SOURCE_PANEL_API, useExisting: RegulationAgentSourceApiService }
  ]
})
export class AgentSourcePanelWrapperComponent {
  @Input() sourceContext: SourceContext | null = null;
  @Input() configdata: ConfigData | null = null;
  @Input() tenantId: string | null = null;
  @Input() domainId: string | null = null;

  @Output() closePanelEvent = new EventEmitter<void>();
}
